// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 600px) {\n.header-form .inputs .m-input-icon {\n    margin-right: 0;\n    width: 100%;\n    max-width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
